import { type ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { LoadingSpinner } from '@/components/shared/LoadingSpinner'
import { dashboardFor } from '@/lib/auth/dashboardFor'

interface Props {
  children: ReactNode
}

/**
 * Inverso di ProtectedRoute: se l'utente è GIÀ autenticato evita le pagine di
 * login e lo porta direttamente alla sua dashboard (o alla destinazione `from`
 * se ProtectedRoute l'aveva impostata). Così chi arriva dal sito pubblico già
 * loggato non deve ri-autenticarsi.
 */
export function RedirectIfAuthenticated({ children }: Props) {
  const { isAuthenticated, isLoading, user } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <LoadingSpinner size="lg" />
      </div>
    )
  }

  if (isAuthenticated && user) {
    const from = (location.state as { from?: { pathname: string } })?.from?.pathname
    return <Navigate to={from ?? dashboardFor(user.role)} replace />
  }

  return <>{children}</>
}
